import { Breakpoints } from "./breakpoints";

export const MediaQuery = {
  desktop: `(min-width: ${Breakpoints.minDesktop}px) and (max-width: ${Breakpoints.maxDesktop}px)`,
  laptop: `(min-width: ${Breakpoints.minLaptop}px) and (max-width: ${Breakpoints.maxLaptop}px)`,
  largeMobile: `(min-width: ${Breakpoints.maxMobile}px) and (max-width: ${Breakpoints.largeMobile}px)`,
  mobile: `(max-width: ${Breakpoints.maxMobile}px)`,
  tablet: `(min-width: ${Breakpoints.minTablet}px) and (max-width: ${Breakpoints.maxTablet}px)`,
  ultraWide: `(min-width: ${Breakpoints.minUltraWide}px)`,
  wide: `(min-width: ${Breakpoints.minWide}px) and (max-width: ${Breakpoints.maxWide}px)`,
};
